import React from "react"
import { ConfirmModal, Action } from "@kit/design/modal"
import { useVerticalNavOptIn } from "./utils/use-vertical-nav-optin"

const FEEDBACK_URL = "https://kit.typeform.com/to/AeIs3RKr"

/**
 * Shown on the classic nav right after a creator reverts from the vertical nav
 * (see `switchToOldNav`). Asks why they switched back. Either button leaves the
 * old-nav hint; giving feedback also opens the survey.
 */
export function VerticalNavRevertModal() {
  const { shouldShowRevertModal, acknowledgeRevert } = useVerticalNavOptIn()

  if (!shouldShowRevertModal) return null

  const giveFeedback = () => {
    window.open(FEEDBACK_URL, "_blank", "noopener,noreferrer")
    acknowledgeRevert()
  }

  return (
    <ConfirmModal
      label="You switched back to the old navigation"
      onClose={acknowledgeRevert}
    >
      Not ready to try the new navigation yet? Tell us why.
      <Action is="secondary" onClick={acknowledgeRevert}>
        Continue
      </Action>
      <Action is="primary" onClick={giveFeedback}>
        Give feedback
      </Action>
    </ConfirmModal>
  )
}
